'use client';

import { AppBar, Box, Slide, Toolbar, Typography, useScrollTrigger } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import NavBarTools from './NavBarTools';

interface NavBarProps {
  toggleTheme: () => void;
  isDarkMode: boolean;
}

export const NavBar = ({ toggleTheme, isDarkMode }: NavBarProps) => {
  const show = !useScrollTrigger();
  return (
    <Slide appear={false} direction='down' in={show}>
      <AppBar position='sticky' elevation={0} color='transparent'>
        <Toolbar
          sx={{
            justifyContent: 'space-between',
            top: '1rem',
            margin: '0 auto',
            width: '60%',
            maxWidth: '900px',
            borderRadius: '2rem',
            backgroundColor: 'white',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          }}
        >
          <Typography
            variant='h2'
            sx={{
              textDecoration: 'none',
              fontSize: '1.2rem',
              color: 'black',
            }}
          >
            Albert Lay
          </Typography>
          <NavBarTools toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
        </Toolbar>
      </AppBar>
    </Slide>
  );
};

export default NavBar;
